module.exports = __webpack_public_path__ + "media/educators/fastweb-mobile-80e43fe5.png";